
export class UserDateRequest {
   
    userName: string;
   
    fromDate: string;
   
    toDate: string;
}